var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.956 6.942c-2.27-2.905-5.604-4.744-9.29-4.744C11.536 2.198 6.32 8.823 6.32 16c0 5.003 3.32 8.747 7.015 8.747a5.66 5.66 0 0 0 1.025-.093c-2.474-1.804-4.057-5.09-4.057-8.654 0-5.675 3.839-10.097 8.363-10.097 4.933 0 8.364 4.9 8.364 10.097-.013 3.838-1.38 7.654-3.79 10.47-2.1 2.458-4.823 4.017-7.816 4.512 0 0 .25.018.576.018 8.284 0 15-6.716 15-15 0-3.403-1.134-6.541-3.044-9.058zM25.68 16c0-5.004-3.321-8.748-7.014-8.748a5.63 5.63 0 0 0-1.026.094c2.474 1.804 4.057 5.09 4.057 8.654 0 5.675-3.839 10.097-8.362 10.097C8.4 26.097 4.97 21.197 4.97 16 4.983 12.162 6.35 8.345 8.76 5.53c2.1-2.458 4.823-4.017 7.816-4.512 0 0-.25-.018-.576-.018C7.716 1 1 7.716 1 16c0 3.403 1.134 6.54 3.044 9.059 2.27 2.903 5.604 4.742 9.29 4.742 7.13 0 12.345-6.625 12.345-13.802z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRose);
export default __webpack_public_path__ + "static/media/ROSE.3c74d02ced052ee0f3f53b84dcb5038a.svg";
export { ForwardRef as ReactComponent };